module.exports = __webpack_public_path__ + "img/1-1.3591dbe3.jpg";